import { COMPLAINT_CASE_LIST_PATH, COMPLAINT_CASE_ADD_PATH, COMPLAINT_CASE_EDIT_PATH, DEFAULT_DELETE_PATH } from '../../constants/paths';
import {ActionWindow} from '../../components/action_window/action_window';
import { complaintCaseAction } from './actions';
import { ComplaintCaseListRoot, complaintCaseListRootLoader, ComplaintCaseList, complaintCaseListLoader } from './complaint_case_list';
import { ComplaintCase, complaintCaseAddLoader, complaintCaseEditLoader } from './complaint_case';
import { AuthProvider } from '../../auth_provider';

const complaintCaseRoutes = [
  {
    path: COMPLAINT_CASE_LIST_PATH.slice(1),
    element: <ComplaintCaseListRoot />,
    loader: complaintCaseListRootLoader,
    shouldRevalidate: () => false,
    children: [
      {
        path: "",
        element: <ComplaintCaseList />,
        loader: complaintCaseListLoader,
        shouldRevalidate: ({ nextUrl, actionResult, formMethod }) => { 
            return AuthProvider.is_authenticated && nextUrl.pathname === COMPLAINT_CASE_LIST_PATH && formMethod && (!actionResult || !actionResult.message);
        },
        children: [
          {
            path: `${DEFAULT_DELETE_PATH.slice(1)}:complaint_case_id`,
            element: <ActionWindow
                title="Deletar caso"
                titleOnLoading="Deletando caso"
                titleOnFail="Falha ao deletar caso"
                description="Todos os dados relacionados ao caso serão removidos"
                confirmText="Deletar caso"
                onCancelPath={COMPLAINT_CASE_LIST_PATH}
                onFailPath={COMPLAINT_CASE_LIST_PATH}
                onSuccessPath={COMPLAINT_CASE_LIST_PATH}
                submitMethod="DELETE"
            />,
            action: complaintCaseAction
          }
        ]
      }
    ]
  },
  {
      path: COMPLAINT_CASE_ADD_PATH.slice(1),
      element: <ComplaintCase key="complaint_case:add" isEdit={false} />,
      loader: complaintCaseAddLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: complaintCaseAction
  },
  {
      path: `${COMPLAINT_CASE_EDIT_PATH.slice(1)}:complaint_case_id`,
      element: <ComplaintCase key="complaint_case:edit" isEdit={true} />,
      loader: complaintCaseEditLoader,
      shouldRevalidate: ({ formMethod }) => AuthProvider.is_authenticated && !formMethod,
      action: complaintCaseAction
  },
];

export default complaintCaseRoutes;